import { CalendarIcon } from 'assets/icons';
import { secondaryTextColor } from 'constants/variables';

import resolvedData from 'contentful/ResolveContentfulResponse';
import SharingLinks from 'contentful/sharing_links';
import EvergreenContent from 'components/evergreen/evergreen_content';
import useContentfulPreview from 'hooks/useContentfulPreview';
import PostList from '../post_list';
import BlogPostHero from './blog_post_hero';
import MetaData from '../../../contentful/meta_data';

const BlogPost = ({ content, recentPosts, relatedPosts, products }) => {
  // Parse page content
  const { fields, sys } = useContentfulPreview(content);

  const {
    heroImage,
    title,
    authorName,
    authorTitle,
    evergreenContent,
    seoTitle,
    seoDescription,
    canonicalUrl,
  } = fields;
  const { createdAt } = sys;

  // Format date - e.g. 10 January 2024
  const options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };
  const date = new Date(createdAt);
  const postDate = new Intl.DateTimeFormat('en-GB', options).format(date);

  // Check recentPosts & relatedPosts have data
  const hasRecentPosts = recentPosts && !!resolvedData(recentPosts).length;
  const hasRelatedPosts = relatedPosts && !!resolvedData(relatedPosts).length;

  return (
    <div className="contentful-page v2-container">
      <MetaData
        title={seoTitle}
        description={seoDescription}
        canonicalUrl={canonicalUrl}
      />
      <div className="contentful__grid">
        <section className="blog-intro">
          <h1>{title}</h1>

          <div className="tc-secondary fl ai-c">
            <CalendarIcon
              width={12}
              height={14}
              fillColor={secondaryTextColor}
            />
            <span className="ml-8">{postDate}</span>
          </div>
        </section>
        <main className="blog-post__main">
          <BlogPostHero heroImage={heroImage} />

          {(authorName || authorTitle) && (
            <div className="mb-22">
              {authorName && <p className="fs-16 fw-600 mb-4">{authorName}</p>}
              {authorTitle && (
                <p className="tc-secondary mb-0">{authorTitle}</p>
              )}
            </div>
          )}

          <SharingLinks />

          <EvergreenContent
            content={evergreenContent}
            productReference={products}
          />
        </main>
        <aside className="blog-post__sidebar fl fl-col">
          {hasRelatedPosts && (
            <div>
              <h4 className="blog-post__sidebar-header">Related Articles</h4>
              <PostList posts={relatedPosts} showImages />
            </div>
          )}
          {hasRecentPosts && (
            <div>
              <h4 className="blog-post__sidebar-header">Latest Articles</h4>
              <PostList posts={recentPosts} />
            </div>
          )}
        </aside>
      </div>
    </div>
  );
};

export default BlogPost;
